<template>
  <div class="input-parent">
    <input
      id="date"
      type="text"
      placeholder=""
      ref="input"
      v-model="input"
      :class="[
        'input-field__input',
        { 'input-field__input--focused': isFocused },
      ]"
      @focus="isFocused = true"
      @blur="isFocused = false"
      required
      onfocus="(this.type = 'date')"
      :min="isPastDatesDisabled ? disablePastDates : ''"
    />
    <label
      :for="input"
      @click="clickPlaceholder"
      :class="[
        'input-field__placeholder',
        { 'input-field__placeholder--focused': floatOn },
      ]"
      >{{ placeholder }}
    </label>
  </div>
</template>

<script>
export default {
  name: "DateField",

  components: {},

  data() {
    return {
      input: this.inputValue,
      isFocused: false,
    };
  },

  props: {
    placeholder: {
      type: String,
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    inputValue: {
      type: String,
      default: "",
    },
    isPastDatesDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    floatOn() {
      return this.isFocused || this.input.length > 0;
    },

    disablePastDates() {
      return new Date().toISOString().split("T")[0];
    },
  },

  methods: {
    clickPlaceholder() {
      this.isFocused = true;
      this.$refs.input.focus();
    },
  },

  watch: {
    input(newValue) {
      // emit input to parent element
      this.$emit("onInputChange", {
        [this.fieldName]: newValue,
      });
    },

    inputValue(newValue) {
      this.input = newValue;
    },
  },
};
</script>

<style scoped>
.input-parent {
  position: relative;
  border: 1px solid #fff;
}

#date {
  width: 100%;
  outline: 0;
  padding: 0 8px;
  border: 1.4px solid #000;
  border-radius: 3px;
  transition: 300ms border-color ease;
}

#date:focus {
  border-color: #000;
}

.input-field-wrapper {
  position: relative;
  padding-top: 10px;
}
.input-field__input {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  border: 1.5px solid #545454;
  border-radius: 4px;
  height: 55px;
  outline: none;
  font-size: 13px;
  background: none;
  text-align: left;
  padding-left: 0.7rem;
  margin-bottom: 20px;
}
.input-field__input--focused {
  border: 2px solid #3b3b3b;
}
.input-field__placeholder {
  position: absolute;
  left: 0.8rem;
  top: 1.1rem;
  width: 92%;
  font-size: 13px;
  color: #d3d3d3;
  transition: 0.3s;
  cursor: text;
}
.input-field__placeholder--focused {
  top: -0.5rem;
  left: 0.8rem;
  color: #000;
  font-size: 0.75rem;
  font-weight: 300;
  width: auto;
  z-index: 1;
  background: white;
  padding: 0 3px;
}
</style>
